import "./SwiftStartedSystemPromptComponent.scss";
import template from "./SwiftStartedSystemPromptComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {ReplaySubject} from "rxjs";
export const SwiftStartedPrompt = "tfSwiftStartedPrompt";
export const RemainingDaysToShowPrompt = 5;

export function swiftStartedPrompt(): IComponentOptions {
    return {
        template,
        bindings: {
            daysLeft: "<"
        },
        controllerAs: "ctrl",
        controller: SwiftStartedSystemPromptComponentController
    };
}

export class SwiftStartedSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);
    /** @ngInject */
    public constructor() {
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
